<template>
    <UserStatusChanged v-if="activity.type === ActivityTypes.USER_STATUS_CHANGED.id" :activity="activity" />
    <VisitorBlocked v-else-if="activity.type === ActivityTypes.BLOCK_VISITOR.id" :activity="activity" />
    <VisitorUnBlocked v-else-if="activity.type === ActivityTypes.UNBLOCK_VISITOR.id" :activity="activity" />
    <UserAdded v-else-if="activity.type === ActivityTypes.USER_ADDED.id" :activity="activity" />
    <ChannelCreated v-else-if="activity.type === ActivityTypes.CHANNEL_CREATED.id" :activity="activity" />
    <ChannelRemoved v-else-if="activity.type === ActivityTypes.CHANNEL_REMOVED.id" :activity="activity" />
    <ChatOpened v-else-if="activity.type === ActivityTypes.CHAT_OPENED.id" :activity="activity" />
    <ChatClosed v-else-if="activity.type === ActivityTypes.CHAT_CLOSED.id" :activity="activity" />
    <WebhookAdded v-else-if="activity.type === ActivityTypes.WEBHOOK_ADDED.id" :activity="activity" />
    <WebhookRemoved v-else-if="activity.type === ActivityTypes.WEBHOOK_REMOVED.id" :activity="activity" />
    <TriggerAdded v-else-if="activity.type === ActivityTypes.TRIGGER_ADDED.id" :activity="activity" />
    <TriggerRemoved v-else-if="activity.type === ActivityTypes.TRIGGER_REMOVED.id" :activity="activity" />
    <TriggerUpdated v-else-if="activity.type === ActivityTypes.TRIGGER_UPDATED.id" :activity="activity" />
    <DepartmentAdded v-else-if="activity.type === ActivityTypes.DEPARTMENT_ADDED.id" :activity="activity" />
    <DepartmentRemoved v-else-if="activity.type === ActivityTypes.DEPARTMENT_REMOVED.id" :activity="activity" />
    <RoleAdded v-else-if="activity.type === ActivityTypes.ROLE_ADDED.id" :activity="activity" />
    <RoleRemoved v-else-if="activity.type === ActivityTypes.ROLE_REMOVED.id" :activity="activity" />
    <TagsAdded v-else-if="activity.type === ActivityTypes.TAGS_ADDED.id" :activity="activity" />
    <TagsRemoved v-else-if="activity.type === ActivityTypes.TAGS_REMOVED.id" :activity="activity" />
    <WelcomeMessageAdded v-else-if="activity.type === ActivityTypes.WELCOME_MESSAGE_ADDED.id" :activity="activity" />

    <WelcomeMessageRemoved
        v-else-if="activity.type === ActivityTypes.WELCOME_MESSAGE_REMOVED.id"
        :activity="activity"
    />
    <BannedWordCreated v-else-if="activity.type === ActivityTypes.BANNED_WORD_ADDED.id" :activity="activity" />
    <BannedWordRemoved v-else-if="activity.type === ActivityTypes.BANNED_WORD_REMOVED.id" :activity="activity" />
    <TaskWorkflwCreated v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_CREATED.id" :activity="activity" />
    <SettingsUpdated v-else-if="activity.type === ActivityTypes.SETTINGS_UPDATED.id" :activity="activity" />
    <MailAddressAdded v-else-if="activity.type === ActivityTypes.MAIL_ADDRESS_ADDED.id" :activity="activity" />
    <UserAddedToDepartment
        v-else-if="activity.type === ActivityTypes.USER_ADDED_TO_DEPARTMENT.id"
        :activity="activity"
    />
    <UserRemovedFromDepartment
        v-else-if="activity.type === ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id"
        :activity="activity"
    />
    <TaskDeleted v-else-if="activity.type === ActivityTypes.TASK_DELETED.id" :activity="activity" />
    <ChannelVisibilityChanged
        v-else-if="activity.type === ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id"
        :activity="activity"
    />
    <ContentAdded v-else-if="activity.type === ActivityTypes.CONTENT_ADDED.id" :activity="activity" />
    <ContentRemoved v-else-if="activity.type === ActivityTypes.CONTENT_REMOVED.id" :activity="activity" />
    <CustomerGroupAdded v-else-if="activity.type === ActivityTypes.CUSTOMER_GROUP_ADDED.id" :activity="activity" />
    <CustomerGroupRemoved v-else-if="activity.type === ActivityTypes.CUSTOMER_GROUP_REMOVED.id" :activity="activity" />
    <CustomerGroupUpdated v-else-if="activity.type === ActivityTypes.CUSTOMER_GROUP_UPDATED.id" :activity="activity" />
    <ChatAssigned v-else-if="activity.type === ActivityTypes.CHAT_ASSIGNED_TO_USER.id" :activity="activity" />
    <ChatForwarded v-else-if="activity.type === ActivityTypes.CHAT_FORWARDED_TO_USER.id" :activity="activity" />
    <ChatJoined v-else-if="activity.type === ActivityTypes.USER_JOINED_TO_CHAT.id" :activity="activity" />
    <UserLoggedIn v-else-if="activity.type === ActivityTypes.USER_LOGGED_IN.id" :activity="activity" />
    <TicketAssigned v-else-if="activity.type === ActivityTypes.TICKET_ASSIGNED_TO_USER.id" :activity="activity" />
    <WhatsappBroadcastCreated
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_CREATED.id"
        :activity="activity"
    />
    <WhatsappBroadcastCompleted
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id"
        :activity="activity"
    />
    <WhatsappBroadcastCancelled
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id"
        :activity="activity"
    />
    <WhatsappBroadcastFailed
        v-else-if="activity.type === ActivityTypes.WHATSAPP_BROADCAST_FAILED.id"
        :activity="activity"
    />
    <TaskWorkflowDeleted v-else-if="activity.type === ActivityTypes.TASK_WORKFLOW_DELETED.id" :activity="activity" />
    <BillingAddressUpdated
        v-else-if="activity.type === ActivityTypes.BILLING_ADDRESS_UPDATED.id"
        :activity="activity"
    />
    <InvoiceCreated v-else-if="activity.type === ActivityTypes.INVOICE_CREATED.id" :activity="activity" />
    <InvoicePaymentReceived
        v-else-if="activity.type === ActivityTypes.INVOICE_PAYMENT_RECEIVED.id"
        :activity="activity"
    />
    <InvoicePaymentFailed v-else-if="activity.type === ActivityTypes.INVOICE_PAYMENT_FAILED.id" :activity="activity" />
    <PaymentMethodAdded v-else-if="activity.type === ActivityTypes.PAYMENT_METHOD_ADDED.id" :activity="activity" />
    <InvoiceRefunded v-else-if="activity.type === ActivityTypes.INVOICE_REFUNDED.id" :activity="activity" />
    <LoginFormActivated v-else-if="activity.type === ActivityTypes.LOGIN_FORM_ACTIVATED.id" :activity="activity" />
    <LoginFormDeactivated v-else-if="activity.type === ActivityTypes.LOGIN_FORM_DEACTIVATED.id" :activity="activity" />
    <LoginFormUpdated v-else-if="activity.type === ActivityTypes.LOGIN_FORM_UPDATED.id" :activity="activity" />
    <UserRemoved v-else-if="activity.type === ActivityTypes.USER_REMOVED.id" :activity="activity" />
    <ContactPropAdded v-else-if="activity.type === ActivityTypes.CONTACT_PROP_ADDED.id" :activity="activity" />
    <ContactPropRemoved v-else-if="activity.type === ActivityTypes.CONTACT_PROP_REMOVED.id" :activity="activity" />
    <TaskCreated v-else-if="activity.type === ActivityTypes.TASK_CREATED.id" :activity="activity" />
    <TaskStageChanged v-else-if="activity.type === ActivityTypes.TASK_STAGE_CHANGED.id" :activity="activity" />
    <TaskAssignedToUser v-else-if="activity.type === ActivityTypes.TASK_ASSIGNED_TO_USER.id" :activity="activity" />
    <WhatsappCreditLow v-else-if="activity.type === ActivityTypes.WHATSAPP_CREDIT_LOW.id" :activity="activity" />
    <ChatbotCreated v-else-if="activity.type === ActivityTypes.CHATBOT_CREATED.id" :activity="activity" />
    <ChatBotCreditLow v-else-if="activity.type === ActivityTypes.CHATBOT_CREDIT_LOW.id" :activity="activity" />
    <ChatBotCreditDone v-else-if="activity.type === ActivityTypes.CHATBOT_CREDIT_DONE.id" :activity="activity" />
    <SystemStatusChanged v-else-if="activity.type === ActivityTypes.SYSTEM_STATUS.id" :activity="activity" />
    <ChatbotDeleted v-else-if="activity.type === ActivityTypes.CHATBOT_DELETED.id" :activity="activity" />
    <ChatbotPublished v-else-if="activity.type === ActivityTypes.CHATBOT_PUBLISHED.id" :activity="activity" />
    <PlanStarted v-else-if="activity.type === ActivityTypes.PLAN_STARTED.id" :activity="activity" />
    <PlanCanceled v-else-if="activity.type === ActivityTypes.PLAN_CANCELED.id" :activity="activity" />
    <WhatsappV1BotStateChanged
        v-else-if="activity.type === ActivityTypes.WHATSAPP_V1_BOT_STATE_CHANGED.id"
        :activity="activity"
    />
    <WhatsappV2BotStateChanged
        v-else-if="activity.type === ActivityTypes.WHATSAPP_V2_BOT_STATE_CHANGED.id"
        :activity="activity"
    />
    <ReservationCreatedPlan
        v-else-if="activity.type === ActivityTypes.RESERVATION_CREATED_PLAN.id"
        :activity="activity"
    />
    <ReservationUpdatedPlan
        v-else-if="activity.type === ActivityTypes.RESERVATION_UPDATED_PLAN.id"
        :activity="activity"
    />
    <ReservationDeletedPlan
        v-else-if="activity.type === ActivityTypes.RESERVATION_DELETED_PLAN.id"
        :activity="activity"
    />
    <ReservationCreated v-else-if="activity.type === ActivityTypes.RESERVATION_CREATED.id" :activity="activity" />
    <ReservationUpdated v-else-if="activity.type === ActivityTypes.RESERVATION_UPDATED.id" :activity="activity" />
    <ReservationDeleted v-else-if="activity.type === ActivityTypes.RESERVATION_DELETED.id" :activity="activity" />
    <div v-else>
        {{ activity.type }}
    </div>
</template>
<script>
import Vue from "vue";
import UserStatusChanged from "./UserStatusChanged.vue";
import ActivityTypes from "../ActivityTypes";
import VisitorBlocked from "./VisitorBlocked.vue";
import VisitorUnBlocked from "./VisitorUnBlocked.vue";
import UserAdded from "./UserAdded.vue";
import ChannelCreated from "./ChannelCreated.vue";
import ChannelRemoved from "./ChannelRemoved.vue";
import ChatOpened from "./ChatOpened.vue";
import ChatClosed from "./ChatClosed.vue";
import WebhookAdded from "./WebhookAdded.vue";
import WebhookRemoved from "./WebhookRemoved.vue";
import TriggerAdded from "./TriggerAdded.vue";
import TriggerRemoved from "./TriggerRemoved.vue";
import TriggerUpdated from "./TriggerUpdate.vue";
import DepartmentAdded from "./DepartmentAdded.vue";
import DepartmentRemoved from "./DepartmentRemoved.vue";
import RoleAdded from "./RoleAdded.vue";
import RoleRemoved from "./RoleRemoved.vue";
import TagsAdded from "./TagsAdded.vue";
import TagsRemoved from "./TagsRemoved.vue";
import WelcomeMessageAdded from "./WelcomeMessageAdded.vue";
import WelcomeMessageRemoved from "./WelcomeMessageRemoved.vue";
import BannedWordCreated from "./BannedWordCreated.vue";
import BannedWordRemoved from "./BannedWordRemoved.vue";
import TaskWorkflwCreated from "./TaskWorkflowCreated.vue";
import SettingsUpdated from "./SettingsUpdated.vue";
import MailAddressAdded from "./MailAddressAdded.vue";
import UserAddedToDepartment from "./UserAddedToDepartment.vue";
import UserRemovedFromDepartment from "./UserRemovedFromDepartment.vue";
import TaskDeleted from "./TaskDeleted.vue";
import ChannelVisibilityChanged from "./ChannelVisibilityChanged.vue";
import ContentAdded from "./ContentAdded.vue";
import ContentRemoved from "./ContentRemoved.vue";
import CustomerGroupAdded from "./CustomerGroupAdded.vue";
import CustomerGroupRemoved from "./CustomerGroupRemoved.vue";
import CustomerGroupUpdated from "./CustomerGroupUpdated.vue";
import ChatAssigned from "./ChatAssigned.vue";
import ChatForwarded from "./ChatForwarded.vue";
import ChatJoined from "./ChatJoined.vue";
import UserLoggedIn from "./UserLoggedIn.vue";
import TicketAssigned from "./TicketAssigned.vue";
import WhatsappBroadcastCreated from "./WhatsappBroadcastCreated.vue";
import WhatsappBroadcastCompleted from "./WhatsappBroadcastCompleted.vue";
import WhatsappBroadcastCancelled from "./WhatsappBroadcastCancelled.vue";
import WhatsappBroadcastFailed from "./WhatsappBroadcastFailed.vue";
import TaskWorkflowDeleted from "./TaskWorkflowDeleted.vue";
import BillingAddressUpdated from "./BillingAddressUpdated.vue";
import InvoiceCreated from "./InvoiceCreated.vue";
import InvoicePaymentReceived from "./InvoicePaymentReceived.vue";
import InvoicePaymentFailed from "./InvoicePaymentFailed.vue";
import PaymentMethodAdded from "./PaymentMethodAdded.vue";
import InvoiceRefunded from "./InvoiceRefunded.vue";
import LoginFormActivated from "./LoginFormActivated.vue";
import LoginFormDeactivated from "./LoginFormDeactivated.vue";
import LoginFormUpdated from "./LoginFormUpdated.vue";
import UserRemoved from "./UserRemoved.vue";
import ContactPropAdded from "./ContactPropAdded.vue";
import ContactPropRemoved from "./ContactPropRemoved.vue";
import TaskCreated from "./TaskCreated.vue";
import TaskStageChanged from "./TaskStageChanged.vue";
import TaskAssignedToUser from "./TaskAssignedToUser.vue";
import WhatsappCreditLow from "./WhatsappCreditLow.vue";
import ChatbotCreated from "./ChatbotCreated.vue";
import ChatBotCreditLow from "./ChatBotCreditLow.vue";
import ChatBotCreditDone from "./ChatBotCreditDone.vue";
import SystemStatusChanged from "./SystemStatusChanged.vue";
import ChatbotDeleted from "./ChatbotDeleted.vue";
import ChatbotPublished from "./ChatbotPublished.vue";
import PlanStarted from "./PlanStarted.vue";
import PlanCanceled from "./PlanCanceled.vue";
import WhatsappV1BotStateChanged from "./Whatsappv1BotStateChanged.vue";
import WhatsappV2BotStateChanged from "./WhatsappV2BotStateChanged.vue";
import ReservationCreatedPlan from "./ReservationCreatedPlan.vue";
import ReservationUpdatedPlan from "./ReservationUpdatedPlan.vue";
import ReservationDeletedPlan from "./ReservationDeletedPlan.vue";
import ReservationCreated from "./ReservationCreated.vue";
import ReservationUpdated from "./ReservationUpdated.vue";
import ReservationDeleted from "./ReservationDeleted.vue";

export default Vue.extend({
    name: "ActivityViewer",
    components: {
        WhatsappBroadcastCancelled,
        WhatsappBroadcastFailed,
        WhatsappBroadcastCompleted,
        WhatsappBroadcastCreated,
        TicketAssigned,
        UserLoggedIn,
        ChatJoined,
        ChatForwarded,
        ChatAssigned,
        ChatClosed,
        ChatOpened,
        ChannelCreated,
        ChannelRemoved,
        UserAdded,
        VisitorUnBlocked,
        VisitorBlocked,
        UserStatusChanged,
        WebhookAdded,
        WebhookRemoved,
        TriggerAdded,
        TriggerRemoved,
        TriggerUpdated,
        DepartmentAdded,
        DepartmentRemoved,
        RoleAdded,
        RoleRemoved,
        TagsAdded,
        TagsRemoved,
        WelcomeMessageAdded,
        WelcomeMessageRemoved,
        BannedWordCreated,
        BannedWordRemoved,
        TaskWorkflwCreated,
        SettingsUpdated,
        MailAddressAdded,
        UserAddedToDepartment,
        UserRemovedFromDepartment,
        TaskDeleted,
        ChannelVisibilityChanged,
        ContentAdded,
        ContentRemoved,
        CustomerGroupAdded,
        CustomerGroupRemoved,
        CustomerGroupUpdated,
        TaskWorkflowDeleted,
        BillingAddressUpdated,
        InvoiceCreated,
        InvoicePaymentReceived,
        InvoicePaymentFailed,
        PaymentMethodAdded,
        InvoiceRefunded,
        LoginFormActivated,
        LoginFormDeactivated,
        LoginFormUpdated,
        UserRemoved,
        ContactPropAdded,
        ContactPropRemoved,
        TaskCreated,
        TaskStageChanged,
        TaskAssignedToUser,
        WhatsappCreditLow,
        ChatbotCreated,
        ChatBotCreditLow,
        ChatBotCreditDone,
        SystemStatusChanged,
        ChatbotDeleted,
        ChatbotPublished,
        PlanStarted,
        PlanCanceled,
        WhatsappV1BotStateChanged,
        WhatsappV2BotStateChanged,
        ReservationCreatedPlan,
        ReservationUpdatedPlan,
        ReservationDeletedPlan,
        ReservationCreated,
        ReservationUpdated,
        ReservationDeleted,
    },
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            ActivityTypes,
        };
    },
});
</script>

<style scoped lang="scss"></style>
